/* Biolink key solutions – homepage showcase (section: biolink-key-solutions) */
(function(){
  function parseSeg(str){return (str||'').split(',').map(function(x){var a=x.split('-');return {s:parseFloat(a[0]),e:parseFloat(a[1])}}).filter(function(x){return !isNaN(x.s)&&!isNaN(x.e)&&x.e>x.s})}
  function ytApi(cb){
    if(window.YT&&YT.Player){cb();return}
    (window.__bksYtq=window.__bksYtq||[]).push(cb);
    if(!window.__bksYtLoading){window.__bksYtLoading=1;var prev=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){if(prev)try{prev()}catch(e){}(window.__bksYtq||[]).forEach(function(f){f()})};var s=document.createElement('script');s.src='https://www.youtube.com/iframe_api';document.head.appendChild(s)}
  }

  function init(root){
    if(!root||root.dataset.ready)return;root.dataset.ready='1';
    var onscreen=false;
    var tabs=[].slice.call(root.querySelectorAll('.bks-tab')),panels=[].slice.call(root.querySelectorAll('.bks-panel'));
    var p1=panels[0];
    function shown(el){return !el.closest('[hidden]')}
    function playIn(scope,on){scope.querySelectorAll('video').forEach(function(v){if(v.closest('[data-bks-duo]'))return;var vis=on&&shown(v);try{vis?v.play():v.pause()}catch(e){}});duoSync()}

    /* Tabs (only when extra tabs are switched on) */
    function select(i,focus){
      tabs.forEach(function(t,k){var on=k===i;t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;panels[k].hidden=!on;playIn(panels[k],on&&onscreen)});
      if(focus)tabs[i].focus();ytSync();
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){select(i)});
      t.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();select((i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length,true)}});
    });

    /* Play only the chosen scenes of a video: data-bks-seg="22-33,39-43.5" (seconds) */
    root.querySelectorAll('video[data-bks-seg]').forEach(function(v){
      var seg=parseSeg(v.getAttribute('data-bks-seg'));if(!seg.length)return;var i=0;v.loop=false;
      function go(k){i=k;try{v.currentTime=seg[i].s}catch(e){}}
      v.addEventListener('loadedmetadata',function(){go(0)});
      if(v.readyState>0)go(0);
      v.addEventListener('timeupdate',function(){var t=v.currentTime;if(t<seg[i].s-0.5||t>=seg[i].e){go((t>=seg[i].e)?(i+1)%seg.length:i)}});
      v.addEventListener('ended',function(){go(0);v.play()});
    });

    /* Design clips: play a few seconds of each video one after another, with a crossfade */
    var duos=[].slice.call(root.querySelectorAll('[data-bks-duo]'));
    duos.forEach(function(d){
      var clips=[].slice.call(d.querySelectorAll('.bks-duo__clip'));if(!clips.length)return;
      d._cur=0;d._clips=clips;
      clips.forEach(function(c){
        c._segs=parseSeg(c.getAttribute('data-seg'));if(!c._segs.length)c._segs=[{s:0,e:5}];c._si=0;c._v=c.querySelector('video');
        function seg(){return c._segs[c._si]}
        c._reset=function(){c._si=0;try{c._v.currentTime=c._segs[0].s}catch(e){}};
        c._v.addEventListener('loadedmetadata',function(){if(clips[d._cur]!==c||!d._on)c._reset()});
        c._v.addEventListener('timeupdate',function(){if(clips[d._cur]!==c)return;var t=c._v.currentTime,s=seg();
          if(t>=s.e){if(c._si<c._segs.length-1){c._si++;try{c._v.currentTime=seg().s}catch(e){}}else{d._go((d._cur+1)%clips.length)}}
          else if(t<s.s-0.5){try{c._v.currentTime=s.s}catch(e){}}});
        c._v.addEventListener('ended',function(){if(clips[d._cur]===c)d._go((d._cur+1)%clips.length)});
      });
      d._go=function(i){
        d._cur=i;var c=clips[i];c._reset();
        clips.forEach(function(x,k){x.classList.toggle('is-on',k===i)});
        if(d._on){var p=c._v.play();if(p&&p.catch)p.catch(function(){})}
        setTimeout(function(){clips.forEach(function(x,k){if(k!==d._cur){try{x._v.pause()}catch(e){}x._reset()}})},650);
      };
      clips[0].classList.add('is-on');
    });
    function duoSync(){duos.forEach(function(d){if(!d._clips)return;var on=onscreen&&shown(d);if(on===d._on)return;d._on=on;var c=d._clips[d._cur];if(on){var p=c._v.play();if(p&&p.catch)p.catch(function(){})}else{d._clips.forEach(function(x){try{x._v.pause()}catch(e){}})}})}

    /* YouTube clips: muted, chosen scenes only, YouTube buttons never visible.
       The player is loaded and started as soon as the section comes on screen (whatever step is open),
       so it is already playing when the visitor reaches that step. It stays invisible until it is
       playing and is hidden again before it pauses, so YouTube's own buttons never show. */
    var ytBoxes=[].slice.call(root.querySelectorAll('[data-bks-yt]'));
    function reveal(box){clearTimeout(box._rv);box._rv=setTimeout(function(){var p=box._p;if(p&&p.getPlayerState&&p.getPlayerState()===1)box.classList.add('is-ready')},700)}
    function ytSync(){ytBoxes.forEach(function(box){
      var show=onscreen;
      if(show&&!box._p&&!box._loading){box._loading=1;ytApi(function(){
        var seg=parseSeg(box.getAttribute('data-bks-seg'));if(!seg.length)seg=[{s:0,e:1e9}];
        var holder=document.createElement('div');box.appendChild(holder);var i=0;
        box._p=new YT.Player(holder,{videoId:box.getAttribute('data-bks-yt'),host:'https://www.youtube-nocookie.com',
          playerVars:{autoplay:1,mute:1,controls:0,disablekb:1,fs:0,iv_load_policy:3,modestbranding:1,playsinline:1,rel:0,showinfo:0,cc_load_policy:0,start:Math.floor(seg[0].s)},
          events:{
            onReady:function(e){e.target.mute();e.target.seekTo(seg[0].s,true);if(onscreen)e.target.playVideo();
              box._t=setInterval(function(){var pl=box._p;if(!pl||!pl.getCurrentTime)return;var t=pl.getCurrentTime();
                if(t>=seg[i].e-0.15||t<seg[i].s-1){i=(t>=seg[i].e-0.15)?(i+1)%seg.length:i;pl.seekTo(seg[i].s,true)}},200)},
            onStateChange:function(e){
              if(e.data===1){reveal(box)}
              else if(e.data===0){box.classList.remove('is-ready');i=0;e.target.seekTo(seg[0].s,true);e.target.playVideo()}
              else if(e.data===2||e.data===-1||e.data===5){box.classList.remove('is-ready')}
            }}});
      })}
      else if(box._p&&box._p.playVideo){
        try{
          if(show){if(box._p.getPlayerState()!==1)box._p.playVideo()}
          else{box.classList.remove('is-ready');clearTimeout(box._rv);box._p.pauseVideo()}
        }catch(e){}
      }
    })}

    /* Workflow steps */
    function closeCmp(){root.querySelectorAll('[data-bks-cmp]').forEach(function(c){c.hidden=true});root.querySelectorAll('[data-bks-cmp-open]').forEach(function(b){b.setAttribute('aria-expanded','false')})}
    function goStep(i){
      closeCmp();
      var rc=root.getBoundingClientRect();if(rc.bottom>0&&rc.top<innerHeight)onscreen=true;
      root.querySelectorAll('[data-bks-step]').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-bks-step')==String(i))});
      root.querySelectorAll('[data-bks-stage]').forEach(function(st){st.hidden=st.getAttribute('data-bks-stage')!=String(i)});
      if(p1)playIn(p1,!p1.hidden&&onscreen);
      ytSync();
    }
    root.querySelectorAll('[data-bks-step]').forEach(function(b){b.addEventListener('click',function(){goStep(b.getAttribute('data-bks-step'))})});
    root.querySelectorAll('[data-bks-next]').forEach(function(b){b.addEventListener('click',function(){goStep(b.getAttribute('data-bks-next'));var o=root.querySelector('.bks-steps');if(o&&o.getBoundingClientRect().top<0)o.scrollIntoView({behavior:'smooth',block:'start'})})});

    /* TRIOS comparison */
    root.querySelectorAll('[data-bks-cmp-open]').forEach(function(b){b.addEventListener('click',function(){
      var c=b.closest('.bks-stage').querySelector('[data-bks-cmp]');if(!c)return;c.hidden=false;b.setAttribute('aria-expanded','true');
      var x=c.querySelector('[data-bks-cmp-close]');if(x)x.focus({preventScroll:true});
      var r=c.getBoundingClientRect();if(r.top<0||r.top>innerHeight*0.6)c.scrollIntoView({behavior:'smooth',block:'start'});
    })});
    root.querySelectorAll('[data-bks-cmp-close]').forEach(function(b){b.addEventListener('click',function(){closeCmp();var o=root.querySelector('[data-bks-cmp-open]');if(o)o.focus({preventScroll:true})})});
    root.addEventListener('keydown',function(e){if(e.key==='Escape')closeCmp()});

    /* Equipment type switcher */
    root.querySelectorAll('[data-bks-type]').forEach(function(b){
      b.addEventListener('click',function(){
        var id=b.getAttribute('data-bks-type');
        root.querySelectorAll('[data-bks-type]').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
        root.querySelectorAll('[data-bks-eq]').forEach(function(p){p.hidden=p.getAttribute('data-bks-eq')!==id});
      });
    });
    /* Handpiece speed filter */
    root.querySelectorAll('[data-bks-hp]').forEach(function(b){
      b.addEventListener('click',function(){
        var f=b.getAttribute('data-bks-hp');
        root.querySelectorAll('[data-bks-hp]').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
        root.querySelectorAll('[data-bks-speed]').forEach(function(c){c.hidden=!(f==='all'||c.getAttribute('data-bks-speed').indexOf(f)>-1)});
      });
    });
    /* Scanner video sound toggle */
    var sb=root.querySelector('[data-bks-sound]');
    if(sb){sb.addEventListener('click',function(){var v=root.querySelector('[data-bks-stage="0"] video');if(!v)return;v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play()}sb.querySelector('span').textContent=v.muted?'Sound on':'Sound off';sb.setAttribute('aria-label',v.muted?'Turn sound on':'Turn sound off')})}
    /* Handpiece video pause/play */
    root.querySelectorAll('[data-bks-toggle]').forEach(function(b){
      b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;if(v.paused){v.play();b.setAttribute('aria-label','Pause video');b.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>'}else{v.pause();b.setAttribute('aria-label','Play video');b.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>'}});
    });

    /* Only play videos while the section is on screen */
    function setOn(v){onscreen=v;var p=root.querySelector('.bks-panel:not([hidden])');if(p)playIn(p,v);ytSync()}
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){setOn(e.isIntersecting)})},{threshold:0.15}).observe(root)}
    else setOn(true);
    document.addEventListener('shopify:block:select',function(e){if(root.contains(e.target)&&tabs[2])select(2)});
  }

  function boot(scope){(scope||document).querySelectorAll('[data-bks]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot()});else boot();
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
